e4.redirect = {
    localStorageKey: 'e4.redirect.consent',
    init: function () {
        var jRedirectModal = jQuery( '#js-e-redirect-msg' );
        if ( jRedirectModal.length === 1 && e4.redirect.getUserConsent() !== false ) {
            jRedirectModal.modal( 'show' );
        }
        e4.redirect.bindEvents();
    },
    bindEvents: function () {
        jQuery( '#js-e-redirect-msg' ).on( 'hide.bs.modal', function ( event ) {
            e4.redirect.setUserConsent( jQuery( event.target ).data( 'redirectConsentExpiration' ) );
        } );
        jQuery( '.js-idd-redirect-modal' ).on( 'click', '.js-idd-redirect-submit', function ( event ) {
            e4.redirect.redirectUserToSelectedLanguage( event.target );
        } );
        jQuery( '.js-language-link' ).on( 'click', function () {
            e4.redirect.setCookie( 'e4.redirect.disabled', true );
        } );
    },
    setCookie: function ( name, value, expire ) {
        document.cookie = name + '=' + value + ';' + ( expire ? expire + ';' : '' ) + 'path=/';
    },
    redirectUserToSelectedLanguage: function ( domElm ) {
        var jModal = jQuery( domElm ).closest( '.js-idd-redirect-modal' ),
            strSelectedLanguage = jModal.find( '.js-rediect-flag-input' ).filter( ':checked' ).val(),
            redirectUrl = jModal.data( 'redirectBaseUrl' ).replace( '[lang]', strSelectedLanguage );
        e4.redirect.setCookie( 'e4.redirect.disabled', false );
        e4.redirect.saveSelectedLanguageCookie( jModal.data( 'redirectConsentExpiration' ), strSelectedLanguage );
        window.location.assign(redirectUrl);
    },
    saveSelectedLanguageCookie: function ( intExpiresInDays, selectedLanguage ) {
        var expires = '';
        if ( intExpiresInDays ) {
            var date = new Date();
            date.setTime( date.getTime() + ( intExpiresInDays * 24 * 60 * 60 * 1000 ) );
            expires = 'expires=' + date.toUTCString();
        }
        e4.redirect.setCookie( 'e4.redirect.language', ( selectedLanguage || '' ), expires );
    },
    setUserConsent: function ( intExpiresInDays ) {
        var intExpiresInMilliSeconds = Math.round( ( jQuery.isNumeric( intExpiresInDays ) === true ? intExpiresInDays : 1 ) * 24 * 60 * 60 * 1000 ),
            jsonStorage = {
                value: JSON.stringify( false ),
                timestamp: new Date().getTime() + intExpiresInMilliSeconds
            };
        localStorage.setItem( e4.redirect.localStorageKey, JSON.stringify( jsonStorage ) );
    },
    getUserConsent: function () {
        var objReturnValue,
            jsonStorage = JSON.parse( localStorage.getItem( e4.redirect.localStorageKey ) );
        if ( jsonStorage !== null ) {
            if ( new Date().getTime() < jsonStorage.timestamp ) {
                objReturnValue = JSON.parse( jsonStorage.value );
            }
            else {
                localStorage.removeItem( e4.redirect.localStorageKey );
                objReturnValue = undefined;
            }
        }
        else {
            objReturnValue = undefined;
        }
        return objReturnValue;
    }
}; 
